import { page } from '$app/state';
import { afterNavigate } from '$app/navigation';
import { isActive } from '$lib/utils/navigation';
import type { Action } from 'svelte/action';

export const active: Action<HTMLAnchorElement, string | undefined> = (node, path) => {
    let href = path ?? node.getAttribute('href') ?? '';
    let element: HTMLAnchorElement | null = node;

    const updateClass = (): void => {
        const currentPath = page.url?.pathname ?? '';
        if (isActive(currentPath, href)) {
            element?.classList.add('active');
        } else {
            element?.classList.remove('active');
        }
    };

    // Use afterNavigate for automatic updates on navigation
    if (typeof window !== 'undefined') {
        afterNavigate(() => updateClass());
    }

    // Initial update to set the correct state
    updateClass();

    return {
        update(newPath?: string): void {
            href = newPath ?? element?.getAttribute('href') ?? '';
            updateClass();
        },
        destroy(): void {
            element = null;
        }
    };
};
